<template>
  <a-row :gutter="20">
    <a-col :span="selectedRowKeys.length > 0 ? 12 : 24">
      <a-card class="card-class" :bordered="false">
        <!-- 查询区域 -->
        <div class="table-page-search-wrapper">
          <a-form class="div-query-banner" layout="inline" @keyup.enter.native="searchQuery">
            <a-form-item label="地址">
              <j-input placeholder="请输入地址" v-model="queryParam.ip"></j-input>
            </a-form-item>
            <a-form-item label="系统类型">
              <j-dict-select-tag
                dictCode="bus_server_sys_type"
                placeholder="请选择系统类型"
                v-model="queryParam.sysType"
              ></j-dict-select-tag>
            </a-form-item>
            <template v-if="toggleSearchStatus">
              <a-form-item label="备注">
                <a-input placeholder="请输入备注" v-model="queryParam.remarks"></a-input>
              </a-form-item>
            </template>
            <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'" />
              </a>
            </span>
          </a-form>
        </div>
        <!-- 查询区域-END -->

        <!-- 操作按钮区域 -->
        <div class="table-operator">
          <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
        </div>

        <!-- table区域-begin -->
        <div>
          <a-table
            ref="table"
            size="middle"
            bordered
            rowKey="id"
            :columns="columns"
            :dataSource="dataSource"
            :pagination="ipagination"
            :loading="loading"
            :scroll="{ x: true }"
            :rowSelection="{ fixed: true, selectedRowKeys: selectedRowKeys, onChange: onSelectChange, type: 'radio' }"
            :customRow="customRow"
            @change="handleTableChange"
          >
            <template slot="izActivity" slot-scope="text">
              <span v-if="text === 1" class="green">启用</span>
              <span v-if="text === 0" class="red">禁用</span>
            </template>
            <span slot="action" slot-scope="text, record">
              <a @click="handleStart(record.startStep)">启动步骤</a>
               <a-divider type="vertical" />
              <a @click="handleEdit(record)">编辑</a>
              <a-divider type="vertical" />
              <a @click="handleConn(record)">测试连接</a>
            </span>
          </a-table>
        </div>
        <busServermanageServers-modal ref="modalForm" @ok="modalFormOk"></busServermanageServers-modal>
        <start-step-modal ref="startStepModal"  ></start-step-modal>
      </a-card>
    </a-col>
    <a-col v-if="selectedRowKeys.length > 0" :span="12" style="height:800px;">
      <a-row style="height: 50%;">
          <service-list :serverId="selectedRowKeys[0]"></service-list>
      </a-row>
      <a-row style="height: 50%;">
          <app-list ref="appList" :serverId="selectedRowKeys[0]"></app-list>
      </a-row>
    </a-col>
  </a-row>
</template>

<script>
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import BusServermanageServersModal from './modules/BusServermanageServersModal'
import JInput from '@/components/jeecg/JInput.vue'
import ServiceList from './components/ServiceList.vue'
import StartStepModal from './modules/StartStepModal.vue'
import AppList from './components/AppList.vue'
import { testConnServer } from '@/api/api.js'
export default {
  name: 'BusServermanageServersList',
  mixins: [JeecgListMixin],
  components: {
    BusServermanageServersModal,
    JInput,
    ServiceList,
    StartStepModal,
    AppList,
  },
  data() {
    return {
      description: '服务器管理______服务器表管理页面',
      // 表头
      columns: [
      {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function (t, r, index) {
            return parseInt(index) + 1
          },
        },
        // {
        //   title: '排序',
        //   align: 'center',
        //   dataIndex: 'sort',
        // },
        {
          title: 'ip地址',
          align: 'center',
          dataIndex: 'ip',
        },
        {
          title: '系统类型',
          align: 'center',
          dataIndex: 'sysType',
        },
        {
          title: '启用',
          align: 'center',
          dataIndex: 'izActivity',
          scopedSlots: {
            customRender: 'izActivity',
          },
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' },
        },
      ],
      /* 排序参数 */
      isorter: {
        column: 'sort',
        order: 'asc',
      },
      url: {
        list: '/servermanage/busServermanageServers/list',
        delete: '/servermanage/busServermanageServers/delete',
        deleteBatch: '/servermanage/busServermanageServers/deleteBatch',
        exportXlsUrl: '/servermanage/busServermanageServers/exportXls',
        importExcelUrl: 'servermanage/busServermanageServers/importExcel',
      },
      dictOptions: {},
      customRow: (record) => {
        return {
          on: {
            click: () => {
              this.onSelectChange([record.id], [record])
            },
          },
        }
      },
    }
  },
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    },
  },
  methods: {
    initDictConfig() {},
    handleStart(startStepStr){
      this.$refs.startStepModal.openNew(startStepStr);
    },
    handleConn(record){
      var params = {}
      params.serverId = record.id;
      testConnServer(params)
          .then((res) => {
            if (res.code == 200 && res.result ==true) {
              this.$message.success(record.ip+"连通测试成功！")
            } else {
              this.$message.error(record.ip+"连通测试失败，请检查服务器是否开启！")
            }
          })
          .catch((err) => {
            if (err && err.message) {
              this.$message.error(err.message)
            }
          })
    }
  },
  watch: {
    dataSource(newVal) {
      if (!newVal[0]) {
        return
      }
      this.onSelectChange([newVal[0].id], [newVal[0]])
    },
  },
}
</script>
<style lang="less" scoped>
@import '~@assets/less/common.less';
.red {
  color: red;
}
.green {
  color: green;
}
.card-class {
  min-height: 900px;
}
.div-query-banner {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  & > *:nth-child(n) {
    width: 300px;
  }
  & > *:nth-child(n + 2) {
    margin-left: 12px;
  }
  & > .ant-btn {
    width: 100px;
  }
  & > a{
    width: 60px;
    height: 30px;
  }
}
</style>